<script setup lang="ts">
import { isDesktop } from "~/utils/platform"

// We need a way to tell if we are in windows, mac, linux, or web.
// On windows, we currently need to set the background as fully
// transparent, as the mica background effect will take over. In
// mac, we need to strategically set the color such that the
// unfocused color also looks good.
// NOTE: Do NOT call appMounted on default layout. We need to call it from the page, since
// different pages have different auth requirements.
// NOTE: We have a `nuxt-page` element here as a token for Nuxt, but we actually don't use
// the nuxt page hierarchy in the main application, since we want to control the navigation
// and lifecycle ourselves
useHead({
  bodyAttrs: {
    class: () => `bg-app ${isDesktop() ? "desktop" : "browser"}`,
  },
  titleTemplate: (titleChunk) => {
    if (!titleChunk)
      return "Poly: The Intelligent Cloud File Browser | Join the Waitlist"
    if (titleChunk.length > 60)
      return `${titleChunk.slice(0, 40)}... | Poly: Intelligent Cloud File Storage`
    return `${titleChunk} | Poly: Intelligent Cloud File Storage`
  },
})

const { cacheState } = useCache()

const isLoading = computed(() => !cacheState.value.anonId && !cacheState.value.userId)
</script>

<template>
  <loading-startup-screen v-if="isLoading" />
  <layout-main v-else />
  <slot />
</template>

<style lang="sass">
@import '~/assets/styles/generated/variables.sass'

.bg-app
  @apply text-base t-[#{$global-t-default}]
  &.browser
    @apply bg-[#{$page-bg-primary}]
  &.desktop
    // On desktop there's no main background color as every component styles itself
    // individually
    @apply bg-transparent
</style>
